/**
 * Model to hold a single usawMembership.
 */
export class UsawMembership {
    public static LIMITED_FOLKSTYLE_ID: string = 'ba4f8074-cee9-4412-87de-5eade4314533';

    public id: string;
    public name: string;
    public type: string;
    public isEnabled: boolean;

    public clone(): UsawMembership {
        const clone: UsawMembership = new UsawMembership();
        clone.id = this.id;
        clone.name = this.name;
        clone.type = this.type;
        clone.isEnabled = this.isEnabled;
        return clone;
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: any): UsawMembership {
        const data: any = json['data'] || json;
        const attrs: any = data['attributes'] || {};

        this.id = data.id;
        this.name = attrs.name;
        this.type = attrs.type;
        this.isEnabled = attrs.isEnabled === true;

        return this;
    }
}
